var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Camera component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCamera extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.27795 3.74604C8.41959 3.55719 8.64189 3.44604 8.87795 3.44604H15.121C15.3571 3.44604 15.5794 3.55719 15.721 3.74604L17.8372 6.56758H20.5837C21.1966 6.56758 21.7843 6.81104 22.2177 7.24439C22.651 7.67774 22.8945 8.2655 22.8945 8.87835V18.243C22.8945 18.8558 22.651 19.4436 22.2177 19.8769C21.7843 20.3103 21.1966 20.5537 20.5837 20.5537H3.41526C2.80241 20.5537 2.21465 20.3103 1.7813 19.8769C1.34795 19.4436 1.10449 18.8558 1.10449 18.243V8.87835C1.10449 8.2655 1.34795 7.67775 1.7813 7.24439C2.21465 6.81104 2.80241 6.56758 3.41526 6.56758H6.1618L8.27795 3.74604ZM9.25295 4.94604L7.1368 7.76758C6.99516 7.95644 6.77287 8.06758 6.5368 8.06758H3.41526C3.20023 8.06758 2.99401 8.153 2.84196 8.30505C2.68991 8.4571 2.60449 8.66332 2.60449 8.87835V18.243C2.60449 18.458 2.68991 18.6642 2.84196 18.8163C2.99401 18.9683 3.20023 19.0537 3.41526 19.0537H20.5837C20.7988 19.0537 21.005 18.9683 21.157 18.8163C21.3091 18.6642 21.3945 18.458 21.3945 18.243V8.87835C21.3945 8.66332 21.3091 8.4571 21.157 8.30505C21.005 8.153 20.7988 8.06758 20.5837 8.06758H17.4622C17.2261 8.06758 17.0038 7.95644 16.8622 7.76758L14.746 4.94604H9.25295Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.999 10.0186C10.4738 10.0186 9.2373 11.255 9.2373 12.7803C9.2373 14.3055 10.4738 15.542 11.999 15.542C13.5243 15.542 14.7608 14.3055 14.7608 12.7803C14.7608 11.255 13.5243 10.0186 11.999 10.0186ZM7.7373 12.7803C7.7373 10.4266 9.64535 8.51855 11.999 8.51855C14.3527 8.51855 16.2608 10.4266 16.2608 12.7803C16.2608 15.134 14.3527 17.042 11.999 17.042C9.64535 17.042 7.7373 15.134 7.7373 12.7803Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCamera.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCamera.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCamera.prototype, "size", void 0);
if (customElements.get('cat-icon-camera') === undefined) {
    customElements.define('cat-icon-camera', BlocksIconCamera);
}
